import { fm, privacyLevels } from "lib/localization";

export const COLLECTION_VISIBILITY_PUBLIC = 0;
export const COLLECTION_VISIBILITY_MEMBERS = 2;
export const COLLECTION_VISIBILITY_MANAGERS = 1;

export const orgVisibility = ["Public", "Route Managers Only", "Members Only"];
export const intlOrgVisibility = (intl) => [
  fm(intl, privacyLevels.public),
  fm(intl, privacyLevels.rmOnly),
  fm(intl, privacyLevels.mOnly),
];

export const userVisibility = ["Public", "Private", "Friends Only"];
export const intlUserVisibility = (intl) => [
  fm(intl, privacyLevels.public),
  fm(intl, privacyLevels.private),
  fm(intl, privacyLevels.friendsOnly),
];

export const levelMessage = (level, club, short = false) => {
  if (club) {
    const messages = short
      ? [privacyLevels.public, privacyLevels.managers, privacyLevels.members]
      : [privacyLevels.public, privacyLevels.rmOnly, privacyLevels.mOnly];
    return messages[level];
  } else {
    return [privacyLevels.public, privacyLevels.private, privacyLevels.friendsOnly][level];
  }
};
